import { ReactNode } from 'react';

const MinilottoTicket = ({
  children,
  bonus,
}: {
  children: ReactNode | string;
  bonus?: boolean;
}) => {
  return (
    <div
      className={`minilottoTicket flexCentered ${bonus ? 'bonusEntry' : ''}`}
    >
      <div className="childrenContainer flexCentered">{children}</div>

      <style jsx>
        {`
          .minilottoTicket {
            font-family: 'Press Start 2P', 'Montserrat', sans-serif;
            position: relative;
            padding: 1.3em 1.2em;
            min-width: 55px;
            border: 2px solid #50e3c2;
            border-radius: 4px;
            text-align: center;
            font-size: 1em;
            font-weight: 600;
            margin: 0 0.5em;
          }

          .bonusEntry {
            background-color: #dffcf5;
          }

          @media (min-width: 700px) {
            .minilottoTicket {
              font-size: 1.5em;
              padding: 1.6em 1.7em;
              min-width: 95px;
              border: 4px solid #50e3c2;
              border-radius: 8px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MinilottoTicket;
